import React from "react";
import Modal from "./Modal";
import CalificationModalForm from "./CalificationModalForm";
import { connect } from "react-redux";
import * as actions from "../redux/actions/transactionPendingActions";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

class ModalCalification extends React.Component {
  state = {
    description: "",
    rating: "'0'",
    isConfirmed: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ description: "", rating: "'0'", isConfirmed: null });
    }
  }

  onChangeDescription = (event) => {
    this.setState({ description: event.target.value });
  };

  onSelectSentiment = (val) => {
    this.setState({ isConfirmed: val });
  };

  storeReport = async () => {
    if (this.state.isConfirmed === null) {
      alertify.warning(I18n.t("calification_select_sentiment"));
      return;
    }

    try {
      await this.props
        .AddCalification(this.props.token, {
          message: this.state.description,
          rating: this.state.rating,
          status: this.state.isConfirmed ? "1" : "'0'",
          transaction_id: this.props.transaction.Id,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
      this.props.onClose();
    } catch (error) {
      console.log(error);
    }
  };

  onClickRating = (val) => {
    this.setState({ rating: val });
  };

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        onClose={this.props.onClose}
        title={<Translate value="calification_transaction" />}
      >
        <CalificationModalForm
          isConfirmed={this.state.isConfirmed}
          description={this.state.description}
          onChangeDescription={this.onChangeDescription}
          onClickRating={this.onClickRating}
          onSelectSentiment={this.onSelectSentiment}
          onClose={this.props.onClose}
          onSubmit={this.storeReport}
        />
      </Modal>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
  };
}

const mapDispatchToProps = (dispatch) => ({
  AddCalification: (token, params) =>
    dispatch(actions.newItemCalification({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalCalification);
